import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined'
import { client } from '../../hooks/Client'
import useAvailableSectors from '../../hooks/useAvailableSectors'
import { getSectorInfo } from '../../helpers/meetstandaard/sectorCatalog'

/**
 * Onderzoeksdata meetstandaard card (superTenant only) — ingang voor de
 * meetstandaard-onderzoekers. Kies een sector (of de hele meetstandaard)
 * en klik door naar de onderzoeksdata-pagina met Cronbach's alpha en
 * factoranalyse over alle organisaties.
 *
 * Berekent zelf niets: de dataset kost één Cloud Function-call per
 * MSI-effect, veel te zwaar voor elke dashboard-load.
 *
 * Leest `selectableSectors`, niet `sectors`: de keuzelijst moet elke sector
 * bevatten waar we onderzoeksdata voor kunnen hebben, ook als de api die sector
 * (nog) niet in zijn catalogus publiceert. Met `sectors` viel energiearmoede
 * hier stil uit de dropdown — de onderzoeker kon hem simpelweg niet kiezen.
 *
 * AI-CONTEXT: See docs/pitfalls.md#api-dual-pipeline-legacy-only-consumer
 *
 * @param {object} props - Geen props; de kaart is self-contained
 */
const DashboardMsiResearchDataCard = () => {
    const history = useHistory()
    const { selectableSectors } = useAvailableSectors()
    const [selectedSector, setSelectedSector] = useState('')

    const openResearchData = () => {
        const query = selectedSector ? `?sector=${selectedSector}` : ''
        history.push(`/${client}/deepanalysis/meetstandaard${query}`)
    }

    return (
        <div className='dashboard-research-data-card'>
            <p className='new-dashboard-card-label'>
                <span>Onderzoeksdata meetstandaard</span>
                <span className='new-dashboard-card-label-type new-dashboard-card-label-type-msi'>
                    Deccos
                </span>
            </p>
            <p className='dashboard-research-data-card-description'>
                Cronbach&#39;s alpha en factoranalyse over de MSI-effecten van alle
                organisaties, met de onderliggende (geanonimiseerde) data.
            </p>
            <select
                className='dashboard-research-data-card-select'
                value={selectedSector}
                onChange={(e) => setSelectedSector(e.target.value)}
            >
                <option value=''>Hele meetstandaard</option>
                {selectableSectors.map((slug) => (
                    <option key={slug} value={slug}>{getSectorInfo(slug).label}</option>
                ))}
            </select>
            <div className='dashboard-research-data-card-button' onClick={openResearchData}>
                <QueryStatsOutlinedIcon />
                <p>Open onderzoeksdata</p>
            </div>
        </div>
    )
}

export default DashboardMsiResearchDataCard
